import { inject, provideEnvironmentInitializer } from '@angular/core';

import { Container } from 'inversify';

import { BAAS_TOAST_PORT, BaasToastPort } from '@lvflanders/bar-ui';

import { BAR_UI_BUNDLE_LOADED } from '../controls/tokens';
import { BaasToastPortAdapter } from './baas-toast-port-adapter';

/**
 * Registers the BaasToastPort adapter in the inversify container.
 * This bridges the Angular BaasToastMessageService with the inversify-managed BaasToastPort interface.
 * Only registers if the Container is available (i.e., when using withBaasAppBehavior).
 */
export function provideBaasToastPortAdapter() {
    return [
        BaasToastPortAdapter,
        provideEnvironmentInitializer(() => {
            const isBundleLoaded = inject(BAR_UI_BUNDLE_LOADED);
            if (!isBundleLoaded) return;

            const container = inject(Container, { optional: true });
            if (!container) return;

            const adapter = inject(BaasToastPortAdapter);

            // Unbind any existing binding and bind the Angular adapter
            if (container.isBound(BAAS_TOAST_PORT)) {
                container.unbind(BAAS_TOAST_PORT);
            }
            container.bind<BaasToastPort>(BAAS_TOAST_PORT).toConstantValue(adapter);
        })
    ];
}
